<template>
  <div class="rfqf01-status-bar" type="flex">
    <el-row type="flex" class="overall-status" justify="end">
      <el-col tag="span" :span="4">
        <div v-if="componentAlarmMode" class="span-title">·</div>
        <div
          class="span-title"
          @mousedown="handleMouseDown"
          @mouseup="handleMouseUp"
          @touchstart="handleMouseDown"
          @touchend="handleMouseUp"
        >
          {{ $t('报警状态') }}：
        </div>
        <span :class="alarmStatus | alarmClass">{{ alarmStatus | alarmText }}</span>
      </el-col>
      <el-col tag="span" :span="4">
        {{ $t('运行状态') }}：
        <span :class="runState | runClass">{{ runState | runText }}</span>
      </el-col>
    </el-row>
    <div class="common-border mt-15">
      <el-row type="flex" justify="center" align="middle" class="pump-status rfqf01-common-border2">
        <el-col tag="span" :span="6"></el-col>
        <el-col tag="span" :span="6"></el-col>
        <el-col tag="span" :span="6"></el-col>
        <el-col tag="span" :span="6"></el-col>
        <el-col tag="span" :span="6"></el-col>
        <el-col tag="span" :span="6">
          <el-button
            :loading="startLoading"
            :disabled="runState == 6"
            size="small"
            type="primary"
            @click="setState('1')"
          >
            开始测量
          </el-button>
          <el-button :loading="endLoading" size="small" type="danger" @click="setState('0')">
            停止测量
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { tools } from '../utils';

export default {
  props: {
    alarmModel: {
      type: Boolean,
      default: false
    },

    alarmStatus: {
      type: Number,
      default: 0
    },
    runState: {
      type: Number,
      default: 0
    },
    startLoading: {
      type: Boolean,
      default: false
    },
    endLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    alarmModel: {
      deep: true,
      immediate: true,
      handler(val) {
        this.componentAlarmMode = val;
      }
    }
  },
  data() {
    return {
      componentAlarmMode: false
    };
  },
  filters: tools,
  mounted() {
    this.timer = null;
  },
  methods: {
    setState(val) {
      this.$emit('setState', val);
    },
    handleMouseDown() {
      this.timer = setTimeout(() => {
        this.timer = null;
        this.componentAlarmMode = !this.componentAlarmMode;
        this.$emit('setAlarmMode', this.componentAlarmMode);
      }, 1000 * 5);
    },
    handleMouseUp() {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
};
</script>

<style lang="scss">
.rfqf01-status-bar {
  .overall-status {
    font-weight: bold;
  }
  .el-col {
    font-size: 18px;
    padding-left: 20px;
    text-align: center;
  }
  .span-title {
    cursor: pointer;
    display: inline-block;
  }
}
</style>
